<template>
  <v-content>
    <div class="containerRefresh pull-to-refresh-material2">
      <div class="pull-to-refresh-material2__control">
        <svg
          class="pull-to-refresh-material2__icon"
          fill="#4285f4"
          width="24"
          height="24"
          viewBox="0 0 24 24">
          <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
          <path
            d="M0 0h24v24H0z"
            fill="none" />
        </svg>

        <svg
          class="pull-to-refresh-material2__spinner"
          width="24"
          height="24"
          viewBox="25 25 50 50">
          <circle
            class="pull-to-refresh-material2__path"
            cx="50"
            cy="50"
            r="20"
            fill="none"
            stroke="#4285f4"
            stroke-width="4"
            stroke-miterlimit="10" />
        </svg>
      </div>
      <v-container 
        fluid>
        <v-layout 
          row
          wrap>
          <v-flex 
            id="profile"
            style="min-width: 360px"
            xs12
            md4>
            <app-profile v-if="!isMobile">
            </app-profile>
          </v-flex>

        
        

          <v-flex 
         
            xs12
            md7
            offset-md5>
            <!-- <div
            id="shadow" /> -->
            <v-flex
              v-if="activeFilter && noFilteredPosts !== true"
              class="text-xs-left"
              xs12>
              <v-btn
                fixed
                small
                class="ml-1 font-weight-bold"
                color="rgba(245,0,87,0.9)"
                dark
                round
                style="font-family: 'Work Sans', sans-serif; z-index: 5; margin-top: 0px;"
                @click="resetFilter()">
                <v-icon
                  class="mr-1"
                  small>
                  far fa-times-octagon
                </v-icon>
                Reset Filter
              </v-btn>
            </v-flex>
            <!-- <v-dialog 
            v-model="loadingPosts" 
            persistent
            full-width
            max-width="300px"
            class="roundedcard">
            <v-card
              style="height: 300px; "
              class="roundedcard"
              color="rgba(255,255,255,0.3)">
              <v-card-text>
                <v-layout
                  align-center
                  justify-center
                  row
                  fill-height>
                  <div class="loader">
                    <div class="inner one" />
                    <div class="inner two" />
                    <div class="inner three" />
                  </div>
                  <span class="white--text font-weight-bold">Loading your content</span>
                </v-layout>
              </v-card-text>
              <v-card-actions>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
         
            <v-content  
              v-if="loadingPosts">
              <!-- <v-content  
            v-if="timelinePosts.length === 0"> -->
              <app-card-loading></app-card-loading>
              <app-card-loading></app-card-loading>
              <app-card-loading></app-card-loading>
            </v-content>

            <!-- v-else-if="user.flags.userIsNew === true || getAllPosts.length === 0" -->
            <v-flex
              v-else-if="user.flags.userIsNew === true"
              class="text-xs-center">
              <app-profile-settings-information class="animated bounceIn delay-1s"></app-profile-settings-information>
            <!-- <app-footer-new 
              class="animated bounceIn delay-1s">
            </app-footer-new> -->
            </v-flex>

            <!-- Affe -->
            <v-flex
              v-else-if="noFilteredPosts === true || getAllPosts.length === 0"
              class="text-xs-center">
              <app-footer-no-filtered-posts
                class="text-xs-center animated bounceIn delay-1s"
                :get-all-posts="getAllPosts">
              </app-footer-no-filtered-posts>
            </v-flex>
            <!-- 
          <v-flex
            v-for="(post, index) in timelinePosts"
            v-else
            :key="index"> -->
            <!-- v-for="(post, index) in getAllPosts" -->
            <v-flex
              v-for="(post, index) in sliced"
              v-else
              :key="index">
              <v-layout 
                v-if="calcDateNew(index)"
                row 
                wrap
                justify-center
                align-center
                class="my-3 mx-3 text-xs-center">
                <v-flex 
                  style="z-index: 1">
                  <hr class="dateline">
                </v-flex>
                <v-flex 
                  shrink 
                  class="mx-4 headline"
                  style="z-index: 1">
                  <span
                    style="color: #90A4AE">
                    {{ displayDay(index) }}
                  </span>
                </v-flex>
                <v-flex style="z-index: 1"> 
                  <hr class="dateline">
                </v-flex>
              </v-layout>
           
              <v-flex
                v-if="index % 4 === 0 && index !== 0"
                xs12
                class="text-xs-center my-3">
                <v-card
                  flat
                  class="roundedcard mx-auto"
                  color="white"
                  max-width="400">
                  <v-card-title>
                    <v-icon
                      large
                      left>
                      fas fa-ad
                    </v-icon>
                    <span class="title font-weight-light">Werbung</span>
                  </v-card-title>

                  <v-card-text class="headline">
                    Hier könnte ihre Werbung stehen
                  </v-card-text>

                  <v-card-actions>
                    <v-list-tile class="grow">
                      <v-list-tile-content>
                        <v-list-tile-title>Hier klicken</v-list-tile-title>
                      </v-list-tile-content>

                      <v-layout
                        align-center
                        justify-end>
                        <v-icon class="mr-1">
                          far fa-ad
                        </v-icon>
                        <span class="subheading mr-2">256</span>
                        <span class="mr-1">·</span>
                        <v-icon class="mr-1">
                          fas fa-share-alt
                        </v-icon>
                        <span class="subheading">45</span>
                      </v-layout>
                    </v-list-tile>
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex
                :class="index % 2 === 0 ? even : odd">
                <keep-alive>
                  <v-content>
                    <app-card-event 
                      v-if="post.subject === 'events'"
                      :post="post"
                      justify-center
                      style="max-width: 600px; margin: auto;">
                    </app-card-event>
                    <app-card-moment 
                      v-if="post.subject === 'moments'"
                      :post="post"
                      justify-center
                      style="max-width: 600px; margin: auto;">
                    </app-card-moment>
                  </v-content>
                </keep-alive>
              </v-flex>
            </v-flex>
            <div
              v-infinite-scroll="loadMore"
              infinite-scroll-disabled="busy"
              infinite-scroll-distance="0" />
            <app-card-loading v-if="busy"></app-card-loading>
            <app-footer-bottom 
              v-if="bottomReached && !user.flags.userIsNew && !loadingPosts && getAllPosts.length !== 0 && !noFilteredPosts" 
              class="animated bounceIn delay-1s">
            </app-footer-bottom>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-content>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
// import { orderBy, debounce, throttle } from 'lodash'

import CardEvent              from '@/components/global_comps/Cards/CardEvent.vue'
import CardMoment             from '@/components/global_comps/Cards/CardMoment.vue'
import CardLoading            from '@/components/global_comps/Cards/CardLoading.vue'
import Profile                from '@/components/View_Profile/ProfileDisplay.vue'
import FooterBottom           from '@/components/View_Timeline/FooterBottom.vue'
// import FooterNew              from '@/components/View_Timeline/FooterNew.vue'
import FooterNoFilteredPosts  from '@/components/View_Timeline/FooterNoFilteredPosts.vue'
import SettingsInformation      from '@/components/View_Profile/SettingsInformation'

import pullToRefresh from 'mobile-pull-to-refresh'
import ptrAnimatesMaterial2 from 'mobile-pull-to-refresh/dist/styles/material2/animates'
import 'mobile-pull-to-refresh/dist/styles/material2/style.css'


export default {
  components: {
    // eslint-disable-next-line
    "app-card-loading": CardLoading,
    // eslint-disable-next-line
    "app-card-event": CardEvent,
    // eslint-disable-next-line
    "app-card-moment": CardMoment,
    'app-profile': Profile,
    'app-footer-bottom': FooterBottom,
    // 'app-footer-new': FooterNew,
    'app-footer-no-filtered-posts': FooterNoFilteredPosts,
    // eslint-disable-next-line
    'app-profile-settings-information': SettingsInformation,

  },
  data() {
    return {
      
      even: 'md9 offset-md1 xs12',
      odd: 'md9 offset-md2 xs12',
     

      bottomReached: false,
      // loadContent: true,
      
      busy: false,
      // newstart: 0,

      offset : 3,     // items to display after scroll
      display: 5,     // initial items
      trigger: 300,   // how far from the bottom to trigger infinite scroll
     
    }
    
  },

  computed: {
    ...mapState({
      timelineScrollY: state => state.timeline.timelineScrollY,
      noFilteredPosts: state => state.timeline.noFilteredPosts,
      user: state => state.user.user,
      isMobile: state => state.isMobile,
      activeFilter: state => state.timeline.timelineFilter.activeFilter,
      filteredPosts: state => state.timeline.filteredPosts,
      loadedEvents: state => state.timeline.loadedEvents,
      loadedMoments: state => state.timeline.loadedMoments,
    }),
    ...mapGetters({
      getfeaturedPosts: 'getfeaturedPosts',
      locale: 'locale',
      getAllPostsOrdered: 'getAllPostsOrdered',
      getAllFilteredPostsOrdered: 'getAllFilteredPostsOrdered',
      loading: 'loading',
      loadingEvents: 'loadingEvents',
      loadingMoments: 'loadingMoments'
    }),

    getAllPosts() {
     
      if (this.getAllFilteredPostsOrdered.length === 0) {
        console.log('Timeline_Posts:getAllPostsOrdered')
       
        let distance50 = this.getAllPostsOrdered.filter(post => {
          return post.distance < 50
        })
        console.log('getAllPostsOrdered', this.getAllPostsOrdered)
        console.log('distance50', distance50)
        return distance50
      } else {
        console.log('Timeline_Posts:getAllFilteredPostsOrdered')
        let distance50 = this.getAllFilteredPostsOrdered.filter(post => {
          return post.distance < 50
        })
        console.log('getAllFilteredPostsOrdered', this.getAllFilteredPostsOrdered)
        console.log('distance50', distance50)
        return distance50
      }
    },
    // slice the array of data to display
    sliced() {
      return this.getAllPosts.slice(0, this.display)
    },
   
    // throttleScroll () {
    //   return throttle(this.checkIfBottomIsReached, 600)
    // },


    loadingPosts() {
      return this.loadingMoments || this.loadingEvents
    },


  
  },

  created() {
    // this.$store.dispatch('loadEvents')
    // this.$store.dispatch('loadMoments')
    

  },
  mounted () {
    // this.scroll()
    pullToRefresh({
      container: document.querySelector('.containerRefresh'),
      // animates: ptrAnimatesMaterial,
      animates: ptrAnimatesMaterial2,
      // animates: ptrAnimatesIos,
 
      refresh() {
        return new Promise(resolve => {
          // here to fetch the data and rerender the contents.
          setTimeout(resolve, 2000)
        })
      }
    })

  },
  

  destroyed () {
  //   window.onscroll = function () {
  //     window.onscroll = null
  //   }

  },

  beforeRouteLeave (to, from, next) {
    // save this.display for going back to this post
    this.setTimelineScrollY(window.scrollY)
    next()
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
  },
  methods: {
    ...mapActions([
      'resetFilter'
    ]),
    ...mapMutations([
      'setTimelineScrollY',
      'setNoFilteredPosts'
    ]),
    calcDateNew(index) {
      if (index === 0) {
        return true
      } else if (this.displayDay(index) !== this.displayDay(index - 1)) {
        return true
      } else {
        return false
      }
    },
   
    // getAllPostsMethod() {
    //   let distance50 = this.getAllPostsOrdered.filter(function(value, index, arr) {
    //     if (value.distance) {
    //       let numdistance = parseInt(value.distance)
    //       return numdistance <= 50
    //     }
    //   })
    //   return distance50
    // },

    displayDay(index) {
      if (new Date(this.getAllPosts[index].date).toISOString() < new Date().toISOString()) {
        return 'Die letzen 24 h'
      } else if (new Date(this.getAllPosts[index].date).toLocaleDateString(this.locale) === new Date().toLocaleDateString(this.locale)) {
        return 'Heute'
      } else  {
        return this.$options.filters.date(new Date(this.getAllPosts[index].date)) 
      }

    },

    loadMore() {
      this.bottomReached = false

      this.busy = true
      // for (var i = 0, j = 3; i < j; i++) {
      // this.data.push({ name: count++ })
      this.display = this.display + this.offset
      // console.log('load_new')
      // }
      this.busy = false
      if (this.sliced.length >= this.getAllPosts.length) {
        this.bottomReached = true
      }
    }

    
    
    // https://codepen.io/alenabdula/pen/awXzPe 
    // Alternative: npm vue-infinite-loading (https://www.npmjs.com/package/vue-infinite-loading)
    // https://github.com/ElemeFE/vue-infinite-scroll
    // <<< wird derzeit benutzt

    // scroll() {
    //   window.onscroll = ev => {
    //     this.throttleScroll()
       
    //   }
    // },

    // checkIfBottomIsReached () {
    //   console.log('scrollY', window.scrollY)
    //   if (window.innerHeight + window.scrollY >= (this.newstart + document.body.offsetHeight - this.trigger)) {
    //     if (this.display < this.getAllPosts.length) {
    //       this.display = this.display + this.offset
    //       this.newstart = this.newstart + (window.innerHeight - this.trigger)
    //       console.log('display', this.display)
    //     }
    //     else {
    //       this.bottomReached = true
    //     }
    //   }
      
    // },
  }
}
</script>

<style lang="scss" scoped>
// #shadow {
//    transform: rotate(-6deg) scale(1); 
//    margin-top: -200px; 
//    padding: 0; 
//    z-index: 0; 
//    position: fixed; 
//   //  border: 1px solid black; 
//    height: 150vh; 
//    width: 50vh; 
//   //  background-color: red;
//   -webkit-box-shadow: 38px -6px 35px -6px rgba(0,0,0,0.24);
// -moz-box-shadow: 38px -6px 35px -6px rgba(0,0,0,0.24);
// box-shadow: 38px -6px 35px -6px rgba(0,0,0,0.24);
// }

#profile {
  padding-top: 100px;
  position: fixed;
  width: 100% !important;
  top: 0;
  bottom: 0;
  overflow-x: visible;
  overflow-y: scroll;
}

.dateline {
  border: 1px solid #CFD8DC;
}






.loader {
  position: absolute;
  top: calc(50% - 70px);
  left: calc(50% - 70px);
  width: 140px;
  height: 140px;
  border-radius: 50%;
  perspective: 800px;
}

.inner {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: 50%;  
}

.inner.one {
  left: 0%;
  top: 0%;
  animation: rotate-one 1s linear infinite;
  border-bottom: 5px solid #EFEFFA;
}

.inner.two {
  right: 0%;
  top: 0%;
  animation: rotate-two 1s linear infinite;
  border-right: 5px solid #EFEFFA;
}

.inner.three {
  right: 0%;
  bottom: 0%;
  animation: rotate-three 1s linear infinite;
  border-top: 5px solid #EFEFFA;
}

@keyframes rotate-one {
  0% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
  }
}

@keyframes rotate-two {
  0% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
  }
}

@keyframes rotate-three {
  0% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
  }
}
</style>
